export const REVIEW_WORKFLOW_STAGE_SORT_OPTION_NAME = {
  value: 'strapi_stage[name]',
  label: {
    id: 'settings.defaultSortOrder.reviewWorkflows.label',
    defaultMessage: 'Review Stage',
  },
};
